import differenceInCalendarYears from 'date-fns/differenceInCalendarYears';
import { sanitizeObject } from 'core/helpers/misc';

export const updateFormFields = (quote, setFieldValue, currentValues) => {
  // applicant details
  if (quote.fname) {
    setFieldValue('firstName', quote.fname);
  }
  if (quote.lname) {
    setFieldValue('lastName', quote.lname);
  }
  if (quote.correctedAddress) {
    setFieldValue('address', quote.correctedAddress.address);
    setFieldValue('city', quote.correctedAddress.city);
    setFieldValue('state', quote.correctedAddress.state);
    setFieldValue('zip', quote.correctedAddress.zip);
  }
  if (quote.phone) {
    setFieldValue('phone', quote.phone);
  }
  if (quote.email) {
    setFieldValue('email', quote.email);
  }
  if (quote.leadSource) {
    setFieldValue('leadSource', quote.leadSource);
  }

  // personal details section
  if (quote.drivers?.length) {
    setFieldValue('dateOfBirth', quote.drivers[0]?.dateOfBirth);
    setFieldValue('driversLicenseNumber', quote.drivers[0]?.driversLicenseNumber);
    setFieldValue('driversLicenseState', quote.drivers[0]?.driversLicenseState);
  }

  // prior address section
  if (quote.priorAddress) {
    setFieldValue('priorAddress', quote.priorAddress);
  }

  // current auto details section
  if (quote.autoCoverage?.policyLimitBIPD) {
    setFieldValue('policyLimitBIPD', quote.autoCoverage.policyLimitBIPD);
  }
  if (quote.global?.continuousAutoCoverageStartDate) {
    setFieldValue(
      'priorCoverageInYears',
      Math.min(differenceInCalendarYears(new Date(), Date.parse(quote.global?.continuousAutoCoverageStartDate)), 6)
    );
    setFieldValue('insuranceInPast31Days', true);
  }

  // property details section
  if (quote.home) {
    setFieldValue('home', sanitizeObject(quote.home));
  }
  if (quote.condo) {
    setFieldValue('condo', sanitizeObject(quote.condo));
  }
  if (quote.farmLocations) {
    const sanitizedLocations = sanitizeObject(quote.farmLocations);
    // Preserve client-only toggle states that the rater doesn't return
    if (currentValues?.farmLocations) {
      sanitizedLocations.forEach((loc, i) => {
        const currentLoc = currentValues.farmLocations[i];
        if (currentLoc?.useFarmLocationApplicantAddress) {
          loc.useFarmLocationApplicantAddress = currentLoc.useFarmLocationApplicantAddress;
        }
      });
    }
    setFieldValue('farmLocations', sanitizedLocations);
  }
  if (quote.farm) {
    setFieldValue('farm', sanitizeObject(quote.farm));
  }
  if (quote.farmCoverage) {
    setFieldValue('farmCoverage', sanitizeObject(quote.farmCoverage));
  }
  if (quote.entity) {
    setFieldValue('entity', quote.entity);
  }
};
